'use client'

import Tag from '@/components/Tag'
import { useCallback } from 'react'

interface ProjectFiltersProps {
	disciplines: any
	filter?: string
	pathname: string
}

export default function ProjectFilters({
	disciplines,
	filter,
	pathname,
	setActiveFilter: setActiveFilterParent
}: ProjectFiltersProps & {
	setActiveFilter: (value: string) => void
}) {
	const createQueryString = useCallback((name: string, value: string) => {
		return `${name}=${value}`
	}, [])

	return (
		<ul
			className="px-site-margin flex items-center flex-wrap gap-4 mt-[4rem] mb-[2rem] sm:mt-[4rem] sm:mb-[3rem] md:mt-[6rem] md:mb-[4rem]"
			style={{
				opacity: pathname ? 1 : 0
			}}>
			<li>
				<Tag title={'All'} href={pathname} isActive={!filter} />
			</li>
			{disciplines.map((tag: any) => (
				<li key={tag.slug.current}>
					<Tag
						title={tag?.title}
						href={pathname + '?' + createQueryString('filter', tag.slug.current)}
						isActive={filter === tag.slug.current}
					/>
				</li>
			))}
		</ul>
	)
}
